import React, { Component, Fragment } from "react";
import ReactTable from "react-table";
import moment from "moment";

import ProductInfo from "../../products/creactEditeProduct/productForm";
import { Switch } from "antd";
import { Link } from "react-router-dom";
const formatTime = (date) => {
  date = moment(date).format("MMMM Do / YYYY, hh:mm A").split("/");
  return (
    <div>
      <p style={{ margin: 1 }}>{date[0]}</p>
      <p style={{ margin: 1 }}>{date[1]}</p>
    </div>
  );
};
export class Datatable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedValues: [],
      myData: [],
      modalDelete: false,
    };
  }
  componentDidMount() {
    this.setState({
      checkedValues: [],
      myData: this.props.myData,
      modalDelete: false,
    });
    //console.log("------------", this.props);
  }

  selectRow = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues: this.state.checkedValues.filter((item, j) => i !== item),
      });
    } else {
      this.state.checkedValues.push(i);
      this.setState({
        checkedValues: this.state.checkedValues,
      });
    }
  };

  handleRemoveRow = () => {
    const { removeScanedEmail } = this.props;
    this.setState({ modalDelete: false });
    removeScanedEmail(this.state.checkedValues);
  };

  renderEditable = (cellInfo) => {
    return (
      <div
        style={{ backgroundColor: "#fafafa" }}
        contentEditable
        suppressContentEditableWarning
        onBlur={(e) => {
          const data = [...this.props.myData];
          data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
          // this.setState({ myData: data });
        }}
        dangerouslySetInnerHTML={{
          __html: this.props.myData[cellInfo.index][cellInfo.column.id],
        }}
      />
    );
  };

  Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  render() {
    const {
      loading,
      pageSize,
      page,
      totalRecords,
      myClass,
      multiSelectOption,
      pagination,
      onChangePageSize,
      onChangePage,
      myData,
      categoryStatus,
      onEditInfo,
      onChangeActive,
      brandsList,
      categoryList,
    } = this.props;
    const columns = [
      // {
      //   Header: (
      //     <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
      //       Product Name
      //     </h6>
      //   ),
      //   accessor: "productId.name",
      //   Cell: null,
      //   style: {
      //     textAlign: "center",
      //   },
      // },
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px", padding: "15px 10px" }}>
            Client Name
          </h6>
        ),
        accessor: "clientId.name",
        Cell: null,
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      },
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px", padding: "15px 10px" }}>
            Client Email
          </h6>
        ),
        accessor: "clientId.email",
        Cell: null,
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      },
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px", padding: "15px 10px" }}>
            Subject
          </h6>
        ),
        accessor: "subject",
        Cell: null,
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      },
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px", padding: "15px 10px" }}>
            Message
          </h6>
        ),
        accessor: "message",
        Cell: null,
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      },
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px", padding: "15px 10px" }}>
            Date
          </h6>
        ),
        accessor: "createdAt",
        Cell: ({ value }) => {
          return <div>{formatTime(value)}</div>;
        },

        heigth: 40,
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      },

      // {
      //   Header: (
      //     <h6
      //       style={{
      //         fontWeight: 600,
      //         margin: 0,
      //         letterSpacing: "0px",
      //       }}
      //     >
      //       Status
      //     </h6>
      //   ),
      //   accessor: "public",
      //   width: 100,
      //   Cell: ({ value, original, index }) => {
      //     console.log(index, !value, "original._id, !value");
      //     return (
      //       <div style={{}}>
      //         <Switch
      //           // loading={selectedIndex === index && loader ? true : false}
      //           defaultChecked={value}
      //           onChange={() => onChangeActive(original._id, !value, index)}
      //         />
      //       </div>
      //     );
      //   },
      // },
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px", padding:"15px 10px" }}>
            Status
          </h6>
        ),
        accessor: "isApproved",
        width: 100,
        Cell: ({ value, original, index }) => {
          return (
            <div style={{ alignContent: "center" }}>
              {original.staffMemberId ? (
                original.isApproved ? (
                  <p
                    style={{
                      background: "green",
                      borderRadius: "25px",
                      color: "#ffffff",
                      fontWeight: 600,
                      textAlign: "center",
                      marginBottom: "0px"
                    }}
                  >
                    {"Approved"}
                  </p>
                ) : (
                  <p
                    style={{
                      background: "red",
                      borderRadius: "25px",
                      color: "#ffffff",
                      fontWeight: 600,
                      textAlign: "center",
                      marginBottom: "0px"
                    }}
                  >
                    {"Disapproved"}
                  </p>
                )
              ) : (
                <p
                  style={{
                    background: "gray",
                    borderRadius: "25px",
                    color: "#ffffff",
                    fontWeight: 600,
                    textAlign: "center",
                    marginBottom: "0px"
                  }}
                >
                  {"Pending"}
                </p>
              )}
            </div>
          );
        },
        style: {
          alignContent: "center"
        },
      },
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px", padding: "15px 10px" }}>
            Action
          </h6>
        ),
        accessor: "isApproved",
        width: 100,
        Cell: ({ value, original, index }) => {
          return (
            <div style={{}}>
              {original.staffMemberId ? (
                original.isApproved ? (
                  <i
                    className="bi bi-x-circle"
                    style={{
                      fontSize: 26,
                      color: "#ff0000",
                      cursor: "pointer",
                    }}
                    onClick={() => onChangeActive(original._id, false, index)}
                  ></i>
                ) : (
                  <i
                    className="bi bi-check-circle"
                    style={{
                      fontSize: 26,
                      color: "#40b240",
                      cursor: "pointer",
                    }}
                    onClick={() => onChangeActive(original._id, true, index)}
                  ></i>
                )
              ) : (
                <>
                  <i
                    className="bi bi-check-circle"
                    style={{
                      fontSize: 26,
                      color: "#40b240",
                      cursor: "pointer",
                      marginRight: "5px"
                    }}
                    onClick={() => onChangeActive(original._id, true, index)}
                  ></i>
                  <i
                    className="bi bi-x-circle"
                    style={{
                      fontSize: 26,
                      color: "#ff0000",
                      cursor: "pointer",
                    }}
                    onClick={() => onChangeActive(original._id, false, index)}
                  ></i>
                </>
              )}
            </div>
          );
        },
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      },
    ];

    return (
      <Fragment>
        <ReactTable
          manual
          data={myData}
          columns={columns}
          className={myClass}
          loading={loading}
          pages={totalRecords}
          page={page}
          pageSize={pageSize || 10}
          showPagination={pagination}
          onPageChange={(pageIndex) => onChangePage(pageIndex)}
          onPageSizeChange={(pageSize, pageIndex) =>
            // //console.log({ pageSize, pageIndex })
            onChangePageSize(pageSize)
          }
          showPagination={pagination}
          onFetchData={(state, instance) => console.log({ state, instance })}
        // SubComponent={(v) => {
        //   console.log({ v });
        //   var original = v.original;
        //   const productInfoProps = {
        //     pictursList: original.productId.pictursList,
        //     productDescription: original.productId.description,
        //     info: original.productId,
        //     isEdit: true,
        //     isView: true,
        //     categoryList: categoryList,
        //     brandsList: brandsList,
        //     pdfFileUrl: original.productId.pdfFileUrl,
        //   };
        //   return (
        //     <>
        //       <ProductInfo {...productInfoProps} />
        //       <div
        //         className="card m-l-20 m-r-20 p-l-25 p-r-25"
        //         style={{ fontWeight: 600 }}
        //       >
        //         <div className="card-title f-20 f-w-6">Description</div>
        //         {/* </div> */}
        //         <div className="card-body">
        //           <div
        //             id="view-inner-html"
        //             dangerouslySetInnerHTML={{
        //               __html: original.productId.description,
        //             }}
        //           ></div>
        //         </div>
        //       </div>
        //     </>
        //   );
        //   // <EmailBodyInfo index={v.row._index} myData={myData} />
        // }}
        />
        {/* <ToastContainer /> */}
      </Fragment>
    );
  }
}

export default Datatable;
